import ErrorToast from "./ErrorToast";
import InfoToast from "./InfoToast";
import SuccessToast from "./SuccessToast";
import WarningToast from "./WarningToast";

const toastTypes = {
  success: SuccessToast,
  error: ErrorToast,
  info: InfoToast,
  warning: WarningToast,
};

const Toast = ({ type = "info", text, animation, animationDuration, onClick }) => {
  const ToastComponent = toastTypes[type];
  return (
    <ToastComponent
      text={text}
      animation={animation}
      animationDuration={animationDuration}
      onClick={onClick}
    />
  );
};

export default Toast;
